import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach bearer token from localStorage on every request (primary auth method)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(idOrPath) {
  if (!idOrPath) return "";
  if (idOrPath.startsWith("http")) return idOrPath;
  if (idOrPath.startsWith("/api/")) return `${BACKEND_URL}${idOrPath}`;
  return `${API}/files/${idOrPath}`;
}
